function alteracaoCadastral(dados) {
    return dados.form;
}

export { alteracaoCadastral };
